import React, { useRef, useEffect, useState } from 'react'

import { useField } from '@unform/core'
import { AutenticacaoContainer, Visao } from 'src/componentes/autenticacao'
import { Obrigatorio } from 'src/componentes/input/styles'

import { Editor } from '../../editor'
import { EditorRef } from '../../editor/tipos'
import { Componente, Label, Erro } from './styles'
import { EditorProps } from './tipos'

export const EditorUnform: React.FC<EditorProps> = ({
  id,
  label,
  name,
  obrigatorio,
  placeholder,
  ...rest
}) => {
  const { visao } = AutenticacaoContainer.useContainer()
  const editorRef = useRef<EditorRef>(null)
  const [caracteresDigitados, definirCaracteresDigitados] = useState<number>(0)

  const {
    fieldName,
    defaultValue,
    registerField,
    error,
    clearError
  } = useField(name)
  useEffect(() => {
    registerField({
      name: fieldName,
      ref: editorRef.current,
      getValue: () => {
        return editorRef.current?.valorHTML()
      },
      setValue: (_: any, value: any) => {
        editorRef.current?.definirValor(value)
      },
      clearValue: () => {
        editorRef.current?.limpar()
      }
    })
  }, [fieldName, registerField])

  useEffect(() => {
    if (defaultValue) {
      const textoSemTags = defaultValue.replace(/<[^>]+>/g, '')
      definirCaracteresDigitados(textoSemTags.length)
    }
  }, [defaultValue])

  return (
    <Componente erro={error} id={`${id}-container`}>
      {label && (
        <Label htmlFor={id}>
          {obrigatorio ? <Obrigatorio>*</Obrigatorio> : null}
          {label}
        </Label>
      )}
      <Editor
        defaultValue={defaultValue}
        ref={editorRef}
        id={id}
        erro={!!error}
        placeholder={placeholder}
        onValorChange={(_valorHtml, plainText) => {
          clearError()
          definirCaracteresDigitados(plainText.length)
        }}
        {...rest}
      />

      {visao === Visao.Aluno && <div>{caracteresDigitados}/500 CARACTERES</div>}
      <Erro id={`erro-${id}`} className="erro">
        {error}
      </Erro>
    </Componente>
  )
}
